import { HeroSection } from './sections/HeroSection'
import { TrustStrip } from './sections/TrustStrip'
import { FeaturesSection } from './sections/FeaturesSection'
import { HowItWorksSection } from './sections/HowItWorksSection'
import { WhatItReadsSection } from './sections/WhatItReadsSection'
import { PricingSection } from './sections/PricingSection'
import { FaqSection } from './sections/FaqSection'
import { ContactSection } from './sections/ContactSection'

// Single scrolling landing page — sections composed in the prototype's scroll
// order: hero, trust strip, features, how-it-works, what-it-reads,
// pricing, FAQ, contact. Nav + footer live in the shared layout.
export const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <TrustStrip />
      <FeaturesSection />
      <HowItWorksSection />
      <WhatItReadsSection />
      <PricingSection />
      <FaqSection />
      <ContactSection />
    </main>
  )
}

export default HomePage
